import _ from 'lodash';

// Finds a template by a provided id and sets the template
export const findAndSetTemplateById = (templateId: string, templates: any) => {
  return _.find(templates, function (o) {
    return o._id === templateId;
  });
};
